import { Stack, Typography } from '@mui/material';
import { vars } from '@tgtg/kit';
import { NavLink } from 'react-router';
import Button from 'ui/Button/Button';

import type { MouseEvent, ReactNode } from 'react';

interface BottomBarButtonProps {
  icon: ReactNode;
  label: string;
  to?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  isActive?: boolean;
}

const BottomBarButton = ({ icon, label, to, onClick, isActive = false }: BottomBarButtonProps) => {
  return (
    <Button
      onClick={to ? undefined : onClick}
      component={to ? NavLink : 'button'}
      to={to}
      variant='ghost'
      sx={{
        borderRadius: vars.radius.medium,
      }}
    >
      <Stack
        direction='column'
        spacing={vars.spacing.neutral.xsmall}
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingY: vars.spacing.neutral.small,
          paddingX: vars.spacing.neutral.large,
          color: isActive ? vars.color.content.brand : vars.color.content.subtle,
        }}
      >
        {icon}
        <Typography variant='labelsXSmall'>{label}</Typography>
      </Stack>
    </Button>
  );
};

export default BottomBarButton;
